import type { BoardPanelHost } from '@workbuddy/ui/v2/blocks/entity.board/components/board.panel/board.panel.host';
import type { OutlineRowPatcher } from '../bulk/outline.bulk.schedule';

/**
 * Shows a confirmed Line / Task Detail save on the outline row it was opened from.
 *
 * In a board panel the tree is reloaded, never patched. An outline row is a server projection
 * (badges, the merged crew, window and duration), so a client patch only mirrors the fields it
 * names, and anything derived — Auto-approve, No crew — stays stale until a page reload. A
 * `collection` refresh purges the SSRM tree, whose root load refetches `loadTree`; expanded rows
 * reopen from the list's own expansion memory. Outside a panel there is no board refresh to ask
 * for, so the named fields are laid over the row in place.
 */
export function showOutlineRowSave(panel: Pick<BoardPanelHost, 'refresh'> | null, board: OutlineRowPatcher | null, rowId: string, rowPatch: Record<string, unknown>): void {

  if (panel) {
    panel.refresh('collection');
    return;
  }
  board?.patchDisplayedRow(rowId, rowPatch);
}
